const getters = {
  token: state => state.auth.token
}

export default getters
